import { Component } from '@angular/core';
import { SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
constructor(
  public sharedSvc:SharedDataService
){

}
}
